import { render, staticRenderFns } from "./estimated-transport-times-card.vue?vue&type=template&id=0fe8449e"
import script from "./estimated-transport-times-card.vue?vue&type=script&lang=js"
export * from "./estimated-transport-times-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports